export default __webpack_public_path__ + "static/media/oatmanKlein.b92221cb.jpg";